import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as fsRecords from '../../fs-entries'

export const RESOURCE = {
  payload: {
    description: 'A single record found in a financial statement',
    dimension: fsRecords.RESOURCE.payload,
    level: 0,
    name: 'Financial Statement Entry',
    partialId: PartialId.Standard.create('fs_entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
